export enum VerificationType {
    MasterPassword = 0,
    OTP = 1,
}
